var React = require('react');

function FlowerDaffodil (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M511.93 336.84C501.94 435 405.57 512 288.17 512h-64.34C106.43 512 10.06 435 .07 336.84-.87 327.72 6.94 320 16.13 320h47.26c63 0 119.82 22.23 160.61 57.92v-96.58A80.33 80.33 0 0 0 256 256a80.33 80.33 0 0 0 32 25.34v96.58C328.79 342.23 385.61 320 448.61 320h47.26c9.19 0 16.98 7.72 16.06 16.84z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M368 144A80 80 0 1 0 256 32a80 80 0 1 0-112 112 80 80 0 1 0 112 112 80 80 0 1 0 112-112zm-112 48a48 48 0 1 1 48-48 48 48 0 0 1-48 48z","className":"fa-primary","key":2})]);
}

FlowerDaffodil.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = FlowerDaffodil;

FlowerDaffodil.default = FlowerDaffodil;
